import { createWizardRoute } from "@roole/components-library";
import { Navigate, Outlet, Route, Routes, useSearchParams } from "react-router-dom";

import React, { ReactElement } from "react";
import { AppRoute } from "./AppRoute";
import { AuthGuard, Footer, Header } from "./components";
import { AuthContextProvider, SubscriptionContextProvider } from "./contexts";
import { SubscriptionWizard } from "./pages";
import DownloadApplication from "./pages/DownloadApplication";
import { PackZeroFranchise } from "./pages/PackZeroFranchise";
import Qrcode from "./pages/Qrcode/Qrcode";
import SignatureContrat from "./pages/SignatureContrat";
import "./styles/index.tailwind.css";

const Layout: React.FC<{ children?: ReactElement }> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header
        partnerLogo={{
          url: "/assets/stellantis.png",
          alt: "Logo Stellantis",
        }}
      />
      {children ?? <Outlet />}

      <Footer />
    </div>
  );
};
export const App = () => {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();

  return (
    <AuthContextProvider>
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Routes>
          <Route
            index
            element={
              <Navigate to={{ pathname: AppRoute.PACK_ZERO_FRANCHISE, search }} replace={true} />
            }
          />

          {createWizardRoute(
            AppRoute.SUBSCRIPTION,
            <Layout>
              <AuthGuard>
                <SubscriptionContextProvider>
                  <SubscriptionWizard />
                </SubscriptionContextProvider>
              </AuthGuard>
            </Layout>
          )}

          {/* Redirection de la page Balise Rx vers la page Pack Zero Franchise */}
          <Route
            path={`${AppRoute.BALISE_RX}/:id?`}
            element={<Navigate to={{ pathname: AppRoute.PACK_ZERO_FRANCHISE, search }} replace={true} />}
          />

          <Route path={AppRoute.QRCODE} element={<Qrcode />} />
          <Route path={AppRoute.DL_APP} element={<DownloadApplication />} />
          <Route path={AppRoute.SIGNATURE_CONTRAT} element={<SignatureContrat />} />
          <Route path={AppRoute.PACK_ZERO_FRANCHISE} element={<PackZeroFranchise />} />

          <Route path="*" element={<Navigate to={{ pathname: "/", search }} replace={true} />} />
        </Routes>
      </div>
    </AuthContextProvider>
  );
};
